export default "__VITE_ASSET__ikQIXE8J__"